import component, { Props } from "./Announce";
export type { Props };
export default component;
